export const ACTION_HOWWORKS_ADD = 'ACTION_HOWWORKS_ADD'
export const ACTION_HOWWORKS_LIST = 'ACTION_HOWWORKS_LIST'
export const ACTION_HOWWORKS_LIST_FAIL = 'ACTION_HOWWORKS_LIST_FAIL'
export const ACTION_HOWWORKS_GET = 'ACTION_HOWWORKS_GET'
export const ACTION_HOWWORKS_GET_FAIL = 'ACTION_HOWWORKS_GET_FAIL'
export const ACTION_HOWWORKS_UPDATE= "ACTION_HOWWORKS_UPDATE"